import styled, { css } from 'styled-components';
import { cssReset, flexCenter } from '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import '../../mixins/font.js';
import { getSizeInRem } from '../../methods/common.js';
import '../../constants/colors.js';
import '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';

const StyledIconWrapper = styled.div `
    ${cssReset}
    ${flexCenter}
    display: inline-flex;
    min-width: fit-content;
    text-decoration: inherit;

    ${({ gap }) => {
    return css `
            gap: ${typeof gap === "number" ? `${gap}px` : gap};
        `;
}}
    img,
    svg {
        ${({ height, width, onClick }) => {
    return css `
                height: ${getSizeInRem(height)};
                width: ${getSizeInRem(width)};
                cursor: ${!!onClick ? "pointer" : "inherit"};
            `;
}}
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: center;
        ${({ rotate }) => rotate &&
    css `
                transform: rotate(${rotate});
            `}
    }

    ${({ svgFillColor }) => svgFillColor
    ? css `
                  svg,
                  svg path {
                      fill: ${svgFillColor};
                  }
              `
    : ""}

    ${({ strokeColor }) => strokeColor
    ? css `
                  svg,
                  svg path {
                      stroke: ${strokeColor};
                  }
              `
    : ""}
`;

export { StyledIconWrapper };
//# sourceMappingURL=IconWrapper.styles.js.map
